/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var productLoadDeliveryInitialized = false;
function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

//HIDE COLORS ON COLLECTION PAGE
if(location.href.indexOf("/collections/") >= 0){
  document.addEventListener('DOMContentLoaded', function load() {
    if (!window.jQuery) return setTimeout(load, 100);
    $(".ProductItem__ColorSwatchItem a[href*='variant=46745377636683']").parent().remove();
    //$(".ProductItem__ColorSwatchItem a[href*='variant=40171206934613']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46745377767755']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=40171200446549']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=47296598573387']").parent().remove();
    //$(".ProductItem__ColorSwatchItem a[href*='variant=40171200577621']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=47300718559563']").parent().remove();


    /** JANE **/
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521408487755']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521408618827']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521407177035']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521407570251']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521407701323']").parent().remove();


    /**ROSA**/
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521408618827']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46521408618827']").parent().remove();

    /*** MARTHA ***/
    $(".ProductItem__ColorSwatchItem a[href*='variant=50218767483211']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=50218767614283']").parent().remove();

    /*** GRACE ***/
    $(".ProductItem__ColorSwatchItem a[href*='variant=46982295159115']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46982295290187']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=47224964710731']").parent().remove();
    $(".ProductItem__ColorSwatchItem a[href*='variant=46982295421259']").parent().remove();

  });
}

/*AJOUT PRIX EN 3X*/

function setAlmaPrice(){
  var productPrice = parseInt($(".gf_product-price").attr("data-price"));
  if(isNaN(productPrice)){
    return;
  }
  if(productPrice >= 10){
    if(/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      $(".gf_product-price + .more-text-price").html("<span aria-label='Vous pouvez payer en 2,3,4 fois sans frais en choisissant la méthode de paiement KLARNA au moment du paiement' data-microtip-position='top' role='tooltip'> ou 4 fois "+(parseInt($(".gf_product-price").attr("data-price"))/4).toFixed(2)+"€</span>");
      $(".gf_product-price .more-text-price").html("<span aria-label='Vous pouvez payer en 2,3,4 fois sans frais en choisissant la méthode de paiement KLARNA au moment du paiement' data-microtip-position='top' role='tooltip'> ou 4 fois "+(parseInt($(".gf_product-price").attr("data-price"))/100/4).toFixed(2)+"€</span>");
    }else{
      $(".gf_product-price + .more-text-price").html("<span aria-label='Vous pouvez payer en 2,3,4 fois sans frais en choisissant la méthode de paiement KLARNA au moment du paiement' data-microtip-position='right' role='tooltip'> ou 4 fois "+(parseInt($(".gf_product-price").attr("data-price"))/4).toFixed(2)+"€</span>");
      $(".gf_product-price .more-text-price").html("<span aria-label='Vous pouvez payer en 2,3,4 fois sans frais en choisissant la méthode de paiement KLARNA au moment du paiement' data-microtip-position='right' role='tooltip'> ou 4 fois "+(parseInt($(".gf_product-price").attr("data-price"))/100/4).toFixed(2)+"€</span>");
    }
  }
}

if(location.href.indexOf("/products/") >= 0){
  document.addEventListener('DOMContentLoaded', function load() {
    if (!window.jQuery) return setTimeout(load, 100);
    var productPrice = parseInt($(".gf_product-price").attr("data-price"));
    console.log("product price:"+productPrice);
    if(isNaN(productPrice)){
      return setTimeout(load, 100);
    }

    setAlmaPrice();


    //REMOVE OUT OF STOCK
    if(item.Name == "Pull Mohair Grace"){
      $(".gf_swatch[data-value='Rose clair']").remove();
      $(".gf_swatch[data-value='Bleu clair']").remove();
      $(".gf_swatch[data-value='Crème']").remove();
      $(".gf_swatch[data-value='Noir']").remove();
      $("option[value='Rose clair']").remove();
      $("option[value='Bleu clair']").remove();
      $("option[value='Crème']").remove();
      $("option[value='Noir']").remove();
    }
    if(item.Name == "Cardigan Monica"){
      $(".gf_swatch[data-value='Lila']").remove();
      //$(".gf_swatch[data-value='Orange']").remove();
      $(".gf_swatch[data-value='Jaune']").remove();
      //$(".gf_swatch[data-value='Rouge']").remove();
      $(".gf_swatch[data-value='Bleu']").remove();
      $(".gf_swatch[data-value='Bleu électrique']").remove();
      //$(".gf_swatch[data-value='Noir']").remove();
      $("option[value='Bleu']").remove();
      $("option[value='Lila']").remove();
      $("option[value='Jaune']").remove();
      $("option[value='Bleu électrique']").remove();
    }
    if(item.Name == "Pull Rosa"){
      $(".gf_swatch[data-value='Jaune']").remove();
      //$(".gf_swatch[data-value='Rose']").remove();
      $(".gf_swatch[data-value='Lila']").remove();
      $(".gf_swatch[data-value='Bleu']").remove();
      $(".gf_swatch[data-value='Crème']").remove();
      $(".gf_swatch[data-value='Noir']").remove();
      $("option[value='Bleu']").remove();
      $("option[value='Lila']").remove();
      $("option[value='Jaune']").remove();
      $("option[value='Crème']").remove();
      $("option[value='Noir']").remove();
    }
    if(item.Name == "Pull Mohair Jane"){
      $(".gf_swatch[data-value='Bleu Med']").remove();
      $(".gf_swatch[data-value='Lila']").remove();
      $(".gf_swatch[data-value='Jaune']").remove();
      $(".gf_swatch[data-value='Orange']").remove();
      $(".gf_swatch[data-value='Bright Pink']").remove();
      $("option[value='Bleu Med']").remove();
      $("option[value='Lila']").remove();
      $("option[value='Jaune']").remove();
      $("option[value='Orange']").remove();
      $("option[value='Bright Pink']").remove();
    }

    if(item.Name == "Pull Martha"){
      /*$(".gf_swatch[data-value='Chocolat']").remove();
      $(".gf_swatch[data-value='Crème']").remove();
      $("option[value='Chocolat']").remove();
      $("option[value='Crème']").remove();*/
    }
    ///
    //HOT FIX UNTIL BETTER PRODUCT PAGE
    //CHANGE COLOR OF OUT OF STOCK ALERT BTN
    /*var elements = document.querySelectorAll('.alert-outofstock.klaviyo-out-of-stock');
    elements.forEach(function(element) {
      element.style.setProperty('background-color', '#8A8A8A', 'important');
    });
    document.getElementById("BIS_trigger").style.setProperty('background-color', '#8A8A8A', 'important');*/
    /////


    ///STOCK DELIVERY CALC
    /*if(!productLoadDeliveryInitialized){
      setProductDeliveryDateEstimate();
    }*/
  });
}

function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

const showRestockDate = function(color, size) {
  /*if(item.Name == "Pull Rosa"){
    if(color == "Rose"){
      if(size == "T2(36/38)" || size == "T3(38/40)" || size == "T4(40/42)"){
        if($(".restock-date-info")[0] != undefined){
          $(".restock-date-info").show();
        }else{
          $("#r-1679391404240").before("<p class='restock-date-info' style='font-size:12px;'>Réassort prévu le 18 avril</p>");
        }
      }else{
        $(".restock-date-info").hide();
      }
    }else{
      $(".restock-date-info").hide();
    }
  }else{
    $(".restock-date-info").hide();
  }*/
}
const opengfPopup = function(id){
  const element = jQuery(id).children('.module')[0];
    const jQueryKey = Object.keys(element).find(key => key.startsWith('jQuery'));
    if (jQueryKey) {
        element[jQueryKey].gfv1popup.show();
    } else {
        console.error("jQuery key not found.");
    }
}


const openSizeGuide = function(){
  if(typeof opengfPopup == "function"){
    try{
      opengfPopup("#m-1626440234308");
    }catch(e){
      console.error("Error opening size guide with gfv1popup:", e);
    }
  }

  const modal = document.getElementById('sizeGuideModal');
  if(modal){
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  return false;
}
//SIZE GUIDE ALT IMAGES
const loadAltDescCarousel = function(){
  const itemName = item.Name;
  const selectors = [".header-carousel .owl-item img", ".owl-mobile .owl-item img", ".product-slider .slide-item img"];
  const images = $(selectors.join(','));

  images.each(function() {
    const altText = $(this).attr("alt");
    if (altText !== itemName) {
      const infoButton = $("<span onclick='openSizeImageInfo(this);' class='info-taille'>Info taille</span>");
      const altTextSpan = $("<span class='alt-text-content' style='display:none;'>" + altText + " | <a style='text-decoration:underline;' onclick='openSizeGuide(); return false;'>Guide des tailles</a></span>");
      
      const container = $("<div class='size-info-container'></div>");
      container.append(infoButton).append(altTextSpan);
      
      $(this).parent().append(container);
    }
  });
}

const openSizeImageInfo = function(e){
  $(e).parent().find(".alt-text-content").show()
  $(e).hide();
}


const ajaxLoaderUpsellProductPage = function(){
  const params = new URLSearchParams(window.location.search);
  params.delete('view');
  if(!params.has('variant') && typeof defaultVariantID !== 'undefined'){
    params.append('variant', defaultVariantID);
  }
  const newQueryString = params.toString();
  var addProduct = "";
  if(item.ProductID){
    addProduct = "&product_id="+item.ProductID;
  }
  fetch('/pages/ajax-upsells-product-page?'+newQueryString+addProduct)
  .then(response => response.text())
  .then(html => {
    if(document.querySelector('.ajaxcart__upsell__product__page')){
      document.querySelector('.ajaxcart__upsell__product__page').innerHTML = html;
    }
  })
  .catch(error => console.error('Error loading the content:', error));
}



const loadReturnDetails = function (returnId, orderId, userEmail) {

  var selected_order = shopifyOrdersData.find(order => order.orderNumber == "#"+orderId);
  console.log("selected_order:", selected_order);
  async function fetchReturnDetails(returnId, orderId, userEmail) {
    const token = btoa('ë~7ó\x9E¹{Í\x9F{ÝÜsw\x1Bw·uyçxÑí:y½\x1B×\x9E´}î\x1Bíý\x1CÛÏ:wO]\x7F]]Û½ß');
    
    try {
      const response = await fetch(`https://live.sympl.fr/api/commands/get-by-recipient?externalReference=${orderId}&recipientCriteria=${userEmail}`, {
        method: 'GET',
        headers: {
          "X-Device-Name": "webapp-retour",
          "X-App-Version": "24",
          "X-Token": token
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.commands && data.commands.length > 0) {
        // Find the command with the matching returnId
        var matchingCommand = data.commands.find(command => command.id == returnId);
        if(matchingCommand == undefined){
          matchingCommand = data.commands.find(command => command.externalReference == orderId);
        }
        
        if (matchingCommand) {
         renderReturnDetails(matchingCommand, selected_order);
        } else {
          document.getElementById('return-details-container').innerHTML = '<p>Détails du retour non trouvés.</p>';
        }
      } else {
        document.getElementById('return-details-container').innerHTML = '<p>Aucun retour trouvé pour cette commande.</p>';
      }
    } catch (error) {
      document.getElementById('return-details-container').innerHTML = `<p>Une erreur est survenue lors du chargement des détails du retour: ${error.message}</p>`;
    }
  }

 async function renderReturnDetails(returnData, order) {
    const container = document.getElementById('return-details-container');

    const returnVoucherRequest = await fetchReturn(returnData.returnVoucher.id);
    if(!returnVoucherRequest.success) return;
   
    const returnVoucherData = returnVoucherRequest.returnVoucher;
    const returnStatus = returnVoucherData.state;
    console.log("Fetched Returns", returnVoucherData);
    var statusSteps = ['created', 'shipment_received', 'refunded'];
    let currentStatusIndex = returnStatus == 'shipment_received' ? 1 : 0;

    if(order.total_refunded_amount > 0){
      currentStatusIndex = 2;
    }else if(returnStatus === 'processed'){
      currentStatusIndex = 2;
      statusSteps = ['created', 'shipment_received', 'processed'];
    }

    const progressPercentage = (currentStatusIndex / (statusSteps.length - 1)) * 100;

    let html = `
      <div class="hide-mobile return-details return-details-desk return-${returnData.externalReference.replace('#', '')}">
        <h2>RETOUR ${returnData.externalReference}</h2>
        <sep></sep>
        <p class="creation-date">COMMANDE DU ${new Date(returnData.created).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${new Date(returnData.created).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</p>
        
        <a href="#" onclick="javascript:loadOrderDetails(${returnData.externalReference.replace('#', '')});" class="btn view-order">VOIR LA COMMANDE</a>

        <div class="items-status-container">
          <div class="items">
            <h3>${returnData.items.length} Article${returnData.items.length > 1 ? 's' : ''}</h3>
            ${returnData.items.map(returnItem => {
              const orderItem = order.lineItems.find(orderItem => orderItem.title === returnItem.description);
              return `
                <div class="item">
                  <img src="${orderItem ? orderItem.image : ''}" alt="${returnItem.description}">
                  <div class="item-details">
                    <p>${returnItem.description}</p>
                    <p class="item-price">${returnItem.sellingPriceValue}€</p>
                    <p class="item-size">Taille ${returnItem.description.split(" / ")[1]}</p>
                    <p class="item-quantity">Quantité : ${returnItem.quantity}</p>
                  </div>
                </div>
              `;
            }).join('')}
          </div>
          
          <div class="status-bar-vertical">
            ${statusSteps.map((step, index) => `
              <div class="status-step ${index <= currentStatusIndex ? 'completed' : ''}">
                <span class="status-label">${getStatusLabel(step)}</span>
              </div>
            `).join('')}
          </div>
        </div>

        ${order.total_refunded_amount ? `<p class="total-refund">TOTAL REMBOURSEMENT ${order.total_refunded_amount.toFixed(2)}€ TTC</p>` : ''}

        <a href="/pages/contact" class="btn question-btn">UNE QUESTION ?</a>
      </div>

      <div class="hide-desk return-details return-details-mobile return-${returnData.externalReference.replace('#', '')}">
        <div class="header-return-details-mobile">
          <h2>RETOUR ${returnData.externalReference}</h2>
          <sep></sep>
          <p class="creation-date">COMMANDE DU ${new Date(returnData.created).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${new Date(returnData.created).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</p>
          
          <a href="#" onclick="javascript:loadOrderDetails(${returnData.externalReference.replace('#', '')});" class="btn view-order">VOIR LA COMMANDE</a>

          <div class="return-status">
            <div class="status-bar-container">
              <div class="status-bar">
                ${statusSteps.map((step, index) => `
                  <div class="status-step ${index <= currentStatusIndex ? 'completed' : ''}" style="transform: translateX(${index === 0 ? '-50%' : index === statusSteps.length - 1 ? '50%' : '0%'})!important;">
                    <span class="status-label">${getStatusLabel(step)}</span>
                  </div>
                `).join('')}
              </div>
            </div>
          </div>
        </div>

        <div class="items-status-container">
          <div class="items">
            <h3>${returnData.items.length} Article${returnData.items.length > 1 ? 's' : ''}</h3>
            ${returnData.items.map(returnItem => {
              const orderItem = order.lineItems.find(orderItem => orderItem.title === returnItem.description);
              return `
                <div class="item">
                  <img src="${orderItem ? orderItem.image : ''}" alt="${returnItem.description}">
                  <div class="item-details">
                    <p>${returnItem.description}</p>
                    <p class="item-price">${returnItem.sellingPriceValue}€</p>
                    <p class="item-size">Taille ${returnItem.description.split(" / ")[1]}</p>
                    <p class="item-quantity">Quantité : ${returnItem.quantity}</p>
                  </div>
                </div>
              `;
            }).join('')}
          </div>
        </div>

        ${order.total_refunded_amount ? `<p class="total-refund">TOTAL REMBOURSEMENT ${order.total_refunded_amount.toFixed(2)}€ TTC</p>` : ''}

        <a href="/pages/contact" class="btn question-btn">UNE QUESTION ?</a>
      </div>

      <style>
        .return-${returnData.externalReference.replace('#', '')} .status-bar::before,
        .return-${returnData.externalReference.replace('#', '')} .status-bar-vertical::before {
          background: linear-gradient(to bottom, 
            black 0%, black ${progressPercentage}%, #e3e3e3 ${progressPercentage}%, #e3e3e3 100%
          );
        }
      </style>
    `;

    container.innerHTML = html;
  }

  function getStatusText(index) {
    const statusTexts = ['Retour créé', 'Retour reçu', 'Remboursé'];
    return statusTexts[index];
  }

  function getStatusLabel(step) {
    const labels = {
      'created': 'Créé',
      'shipment_received': 'Reçu',
      'refunded': 'Remboursé',
      'processed': 'Echange créé'
    };
    return labels[step] || step;
  }

  setTimeout(() => {
    fetchReturnDetails(returnId, orderId, userEmail);
  }, 1000);

}

const loadReturnsList = async function (orderIds, userEmail) {
  const renderReturns = async function (commands) {
    const returnsListElement = document.getElementById('returns-list');
    let returnsHTML = '';

    for (const command of commands) {
      if (!command.returnLabelUrl) continue;

      const returnVoucherRequest = await fetchReturn(command.returnVoucher.id);
      if (!returnVoucherRequest.success) continue;

      const returnVoucherData = returnVoucherRequest.returnVoucher;
      const returnStatus = returnVoucherData.state;

      console.log("Fetched Returns", returnVoucherData);
      
      var statusSteps = ['created', 'shipment_received', 'refunded'];
      let currentStatusIndex = 0;

      const shopifyOrder = shopifyOrdersData.find(order => order.orderNumber === command.externalReference);

      if (command.returnLabelUrl) {
        currentStatusIndex = 0;
      }

      if (returnStatus === 'shipment_received') {
        currentStatusIndex = 1;
      }

      if (shopifyOrder && (shopifyOrder.financialStatus === 'refunded')) {
        currentStatusIndex = 2;
      }else if(returnStatus === 'processed'){
        currentStatusIndex = 2;
        statusSteps = ['created', 'shipment_received', 'processed'];
      }

      const progressPercentage = (currentStatusIndex / (statusSteps.length - 1)) * 100;

      returnsHTML += `
    <div class="return-item return-${command.externalReference.replace('#', '')}">
  <style>
    .return-${command.externalReference.replace('#', '')} .status-bar::before {
      background: linear-gradient(to right, 
        black 0%, black ${progressPercentage}%, #e3e3e3 ${progressPercentage}%, #e3e3e3 100%
      );
    }
  </style>
  <h3 class="hide-mobile"><b><a class="details-button" data-return-id="${command.id}" data-order-id="${command.externalReference.replace('#', '')}">${command.externalReference}</a></b></h3>
  <div class="return-header">
    <div class="return-image">
      <a class="details-button" data-return-id="${command.id}" data-order-id="${command.externalReference.replace('#', '')}"><img src="${command.items[0].pictures[0]}" alt="${command.items[0].description}"></a>
    </div>
    <div class="mobile-right-part">
      <h3 class="hide-desk"><b><a class="details-button" data-return-id="${command.id}" data-order-id="${command.externalReference.replace('#', '')}">${command.externalReference}</a></b></h3>
      <div class="return-info">
        <div class="info-mobile-left-part">
          <p>${new Date(command.created).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          <p>${getStatusText(currentStatusIndex)}</p>
        </div>
        <div class="info-mobile-right-part">
          <p class="hide-desk">${command.items[0].sellingPriceValue}€</p>
          <p>${command.items.length} article${command.items.length > 1 ? 's' : ''}</p>
        </div>
      </div>
      <div class="return-status">
        <div class="status-bar-container">
          <div class="status-bar">
            ${statusSteps.map((step, index) => `
              <div style="transform: translateX(${(index / (statusSteps.length - 1) - 0.5) * 100}%);" class="status-step ${index <= currentStatusIndex ? 'completed' : ''}">
                <span class="status-label">${getStatusLabel(step)}</span>
              </div>
            `).join('')}
          </div>
        </div>
        <div class="return-actions">
          <button class="btn details-button hide-mobile" data-return-id="${command.id}" data-order-id="${command.externalReference.replace('#', '')}">Détail du retour</button>
          <button class="btn details-button hide-desk" data-return-id="${command.id}" data-order-id="${command.externalReference.replace('#', '')}">Détails</button>
          <a href="/pages/contact" class="btn hide-mobile">Contactez-nous</a>
          <a href="/pages/contact" class="btn hide-desk">Contact</a>
        </div>
      </div>
      <div class="return-total">
        <p>${command.items[0].sellingPriceValue}€</p>
      </div>
    </div>
  </div>
</div>
      `;
    }

    return returnsHTML;
  }

  function getStatusText(index) {
    const statusTexts = ['Retour créé', 'Retour reçu', 'Remboursé'];
    return statusTexts[index];
  }

  function getStatusLabel(step) {
    const labels = {
      'created': 'Créé',
      'shipment_received': 'Reçu',
      'refunded': 'Remboursé',
      'processed': 'Echange créé'
    };
    return labels[step];
  }

  async function fetchAndAppendReturnInfo(orderId) {
    const token = btoa('ë~7ó\x9E¹{Í\x9F{ÝÜsw\x1Bw·uyçxÑí:y½\x1B×\x9E´}î\x1Bíý\x1CÛÏ:wO]\x7F]]Û½ß');

    try {
      const response = await fetch(`https://live.sympl.fr/api/commands/get-by-recipient?externalReference=${orderId}&recipientCriteria=${userEmail}`, {
        method: 'GET',
        headers: {
          "X-Device-Name": "webapp-retour",
          "X-App-Version": "24",
          "X-Token": token
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      if (data.success && data.commands.length > 0) {
        const html = await renderReturns(data.commands);
        const returnsListElement = document.getElementById('returns-list');
        returnsListElement.innerHTML += html;
      }
    } catch (error) {
      console.error('Fetch error:', error);
      document.getElementById('returns-list').innerHTML = '<p>Une erreur est survenue lors du chargement de vos retours. Veuillez réessayer plus tard.</p>';
    }
  }

  await Promise.all(orderIds.map(fetchAndAppendReturnInfo))
    .then(() => {
      if (document.getElementById('returns-list').children.length === 0) {
        document.getElementById('returns-list').innerHTML = '<p>Vous n\'avez pas de retours.</p>';
      } else {
        document.querySelectorAll('.details-button').forEach(button => {
          button.addEventListener('click', function () {
            const links = document.querySelectorAll('.nav-link');
            const contentDiv = document.querySelector('.account-content');
            const orderId = this.getAttribute('data-order-id');
            const returnId = this.getAttribute('data-return-id');

            links.forEach(link => link.classList.remove('active'));

            fetch(`/pages/return-details/`)
              .then(response => response.text())
              .then(html => {
                contentDiv.innerHTML = html;
                var accordeons = document.querySelectorAll('.collapsible-accordeon h3');
                accordeons.forEach(function (accordeon) {
                  accordeon.addEventListener('click', function () {
                    var parent = this.parentElement;
                    parent.classList.toggle('active');
                  });
                });

                loadReturnDetails(returnId, orderId, userEmail);

                (function (window, location) {
                  history.replaceState(null, document.title, location.pathname + "#!/specialaccounthistory");
                  history.pushState(null, document.title, location.pathname);

                  window.addEventListener("popstate", function () {
                    if (location.hash === "#!/specialaccounthistory") {
                      history.replaceState(null, document.title, location.pathname);
                      setTimeout(function () {
                        location.replace("/account");
                      }, 0);
                    }
                  }, false);
                }(window, location));
              })
              .catch(error => console.error('Error loading content:', error));
          });
        });
      }
    })
    .catch(error => {
      console.error('Error loading returns info:', error);
      document.getElementById('returns-list').innerHTML = '<p>Une erreur est survenue lors du chargement de vos retours. Veuillez réessayer plus tard.</p>';
    });

}

async function fetchReturn(id) {
  const token = btoa('ë~7ó\x9E¹{Í\x9F{ÝÜsw\x1Bw·uyçxÑí:y½\x1B×\x9E´}î\x1Bíý\x1CÛÏ:wO]\x7F]]Û½ß');

  try {
    const response = await fetch(`https://live.sympl.fr/api/return-vouchers/${id}`, {
      method: 'GET',
      headers: {
        "X-Device-Name": "webapp-retour",
        "X-App-Version": "24",
        "X-Token": token
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    if (data.success) {
      //console.log(data);
      return data;
    }else{
      return {success:false};
    }
  } catch (error) {
    console.error('Fetch error:', error);
    return {success:false,error:error};
  }
}

function loadOrdersListTab() {
  document.querySelectorAll('.details-button').forEach(button => {
    button.addEventListener('click', function () {
      const links = document.querySelectorAll('.nav-link');
      const orderId = this.getAttribute('data-order-id');
      // Remove active class from all links
      links.forEach(link => link.classList.remove('active'));
      // Add active class to the clicked link
      loadOrderDetails(orderId);

    });
  });
}

const loadOrderDetails = function (orderId) {
    // Load the content dynamically
    const contentDiv = document.querySelector('.account-content');

    fetch(`/pages/order-details/${orderId}`)
    .then(response => response.text())
    .then(html => {
      contentDiv.innerHTML = html;
      var accordeons = document.querySelectorAll('.collapsible-accordeon h3');
      accordeons.forEach(function (accordeon) {
        accordeon.addEventListener('click', function () {
          var parent = this.parentElement;
          parent.classList.toggle('active');
        });
      });
      (function (window, location) {
        history.replaceState(null, document.title, location.pathname + "#!/specialaccounthistory");
        history.pushState(null, document.title, location.pathname);

        window.addEventListener("popstate", function () {
          if (location.hash === "#!/specialaccounthistory") {
            history.replaceState(null, document.title, location.pathname);
            setTimeout(function () {
              location.replace("/account");
            }, 0);
          }
        }, false);
      }(window, location));
    })
    .catch(error => console.error('Error loading content:', error));
}


function loadWishlist(elementID) {
  //if(typeof(window.app_store_id)==""){setTimeout(function(){loadWishlist(elementID);},100);return;}
  fetch('https://livewishlist.scriptengine.net/api/apps-wishlist', {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            uuid: window.app_UUID_ID,
            customer_id: window.app_customre_id,
            shopify_store_id: 6192,
            shopify_store: window.Shopify.shop,
            active_currency: 'EUR',
            shop: window.Shopify.shop
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status) {
            const wishlistContainer = document.getElementById(elementID);
            wishlistContainer.innerHTML = '';
            data.data.forEach(item => {
                const wishlistItem = document.createElement('div');
                wishlistItem.classList.add('wishlist-item');

                let sizes = '';
                let selectedVariant = item.variants[item.shopify_variant_id];
                let imgsrc = selectedVariant.image_src ? selectedVariant.image_src : item.image;
                let variantOptions = '';

                // Check if 'Size' or 'Taille' exists as an option
                let sizeOptionsExist = false;
                for (const variantId in item.variants) {
                    const variant = item.variants[variantId];
                    if (variant.title.split(" / ")[0].includes(selectedVariant.title.split(" / ")[0])) {
                        sizeOptionsExist = true;
                        if(variant.title.split(" / ")[1]){
                          sizes += `<span class="variant-option ${item.shopify_variant_id == variant.id ? 'active' : ''}" data-variant-id="${variant.id}" data-price="${variant.price}" data-image="${variant.image}" data-inventory-quantity="${variant.inventory_quantity}">${variant.title.split(" / ")[1]}</span>`;
                        }else{
                          //sizes = `<span>${selectedVariant.title}</span>`;
                        }
                    }
                }

                if (!sizeOptionsExist) {
                    //sizes = `<span>${selectedVariant.title}</span>`;
                }
              
                if (selectedVariant.inventory_policy == "deny" && selectedVariant.inventory_quantity <= 0) {
                    wishlistItem.classList.add('out-of-stock');
                }


              if(elementID == "wishlist-guest-wrapper"){
                wishlistItem.innerHTML = `
                <a href="/products/${item.handle}?variant=${item.shopify_variant_id}">
                    <img src="${imgsrc}" alt="${item.title}" class="variant-image">
                    </a>
                    <div class="info-product-wishlist">
                        <div>
                          <a href="/products/${item.handle}?variant=${item.shopify_variant_id}"><h3>${item.title.split(" / ")[0]}</h3><div class="wishlist-engine" onclick="setTimeout(function(){loadWishlist('wishlist-guest-wrapper');loadWishlist('wishlist-items');},400);" data-product_id="${item.shopify_product_id}" data-variant_id="${item.shopify_variant_id}" data-full_button="true" data-css="true"></div></a>
                          <p>${selectedVariant.title.split(" / ")[0]} / <span style="display:inline;" class="size-options">${sizes}</span></p>
                          <p class="price">${selectedVariant.price}€</p>
                        </div>
                        ${selectedVariant.inventory_policy == "continue" || selectedVariant.inventory_quantity > 0 ? `<button class="add-to-cart" data-variant-id="${item.shopify_variant_id}">Ajouter au panier</button>` : `<button class="BIS_trigger" data-variant-id="${item.shopify_variant_id}" data-product-data='${JSON.stringify({
                          id: item.shopify_product_id,
                          handle: item.handle,
                          tags: [],
                          available: false,
                          variants: Object.values(item.variants).map(variant => ({
                              id: variant.id,
                              title: variant.title,
                              available: variant.inventory_policy == "continue" || variant.inventory_quantity > 0,
                              inventory_quantity: variant.inventory_quantity,
                              inventory_management: variant.inventory_management
                          }))
                      })}'>Créer une alerte</button>`}
                    </div>
                `;
              }else{
                wishlistItem.innerHTML = `
                <a href="/products/${item.handle}?variant=${item.shopify_variant_id}">
                    <img src="${imgsrc}" alt="${item.title}" class="variant-image">
                    </a>
                    <div class="info-product-wishlist">
                        <div>
                          <a href="/products/${item.handle}?variant=${item.shopify_variant_id}"><h3>${item.title.split(" / ")[0]}</h3><div class="wishlist-engine" onclick="setTimeout(function(){loadWishlist('wishlist-guest-wrapper');loadWishlist('wishlist-items');},400);" data-product_id="${item.shopify_product_id}" data-variant_id="${item.shopify_variant_id}" data-full_button="true" data-css="true"></div></a>
                          <p>${selectedVariant.title.split(" / ")[0]} - <span class="price">${selectedVariant.price}€</span></p>
                          <div class="size-options">${sizes}</div>
                        </div>
                        ${selectedVariant.inventory_policy == "continue" || selectedVariant.inventory_quantity > 0 ? `<button class="add-to-cart" data-variant-id="${item.shopify_variant_id}">Ajouter au panier</button>` : `<button class="BIS_trigger" data-variant-id="${item.shopify_variant_id}" data-product-data='${JSON.stringify({
                            id: item.shopify_product_id,
                            handle: item.handle,
                            tags: [],
                            available: false,
                            variants: Object.values(item.variants).map(variant => ({
                                id: variant.id,
                                title: variant.title,
                                available: variant.inventory_policy == "continue" || variant.inventory_quantity > 0,
                                inventory_quantity: variant.inventory_quantity,
                                inventory_management: variant.inventory_management
                            }))
                        })}'>Créer une alerte</button>`}
                    </div>
                `;
              }
                wishlistContainer.appendChild(wishlistItem);
            });

            if(wishlistContainer.innerHTML == ''){
              wishlistContainer.innerHTML = "<p>Vous n'avez pas de favori.</p>";
            }

            document.querySelectorAll('.add-to-cart').forEach(button => {
                $(button).on('click', function() {
                    const variantId = this.getAttribute('data-variant-id');
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: 1
                        })
                    })
                    .then(response => response.json())
                    .then(data => {
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true
                        }));
                        if(elementID == "wishlist-guest-wrapper"){
                          /*closeWishlistDrawer();*/
                          $(this).text("Ajouté au panier");
                          $(this).addClass("added-to-cart");
                          $(this).off("click");
                        }
                    });
                });
            });

            document.querySelectorAll('.variant-option').forEach(option => {
                option.addEventListener('click', function() {
                    const parent = this.closest('.wishlist-item');
                    parent.querySelectorAll('.variant-option').forEach(opt => opt.classList.remove('active'));
                    this.classList.add('active');
                    const variantId = this.getAttribute('data-variant-id');
                    const price = this.getAttribute('data-price');
                    const inventoryQuantity = this.getAttribute('data-inventory-quantity');
                    parent.querySelector('.price').textContent = `${price}€`;
                    const addToCartButton = parent.querySelector('.add-to-cart');
                    if (inventoryQuantity <= 0) {
                        if (addToCartButton) {
                            addToCartButton.remove();
                        }
                    } else {
                        if (!addToCartButton) {
                            const newButton = document.createElement('button');
                            newButton.classList.add('add-to-cart');
                            newButton.setAttribute('data-variant-id', variantId);
                            newButton.textContent = 'Ajouter au panier';
                            parent.querySelector('div').appendChild(newButton);
                            newButton.addEventListener('click', function() {
                                fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        id: variantId,
                                        quantity: 1
                                    })
                                })
                                .then(response => response.json())
                                .then(data => {
                                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                      bubbles: true
                                    }));
                                });
                            });
                        } else {
                            addToCartButton.setAttribute('data-variant-id', variantId);
                        }
                    }
                });
            });
        }else {
            wishlistContainer.innerHTML = "<p>Vous n'avez pas de favori.</p>";
        }
    });
}

function openWishlistDrawer(){
  document.getElementById('sidebar-wishlist').setAttribute('aria-hidden', 'false');
  document.querySelector('.PageOverlay').classList.add('is-visible');
  if(document.getElementById('sidebar-menu')){
    document.getElementById('sidebar-menu').setAttribute('aria-hidden', 'true');
  }
}
function closeWishlistDrawer(){
  document.getElementById('sidebar-wishlist').setAttribute('aria-hidden', 'true');
  /*if(/Mobi|Android/i.test(navigator.userAgent)){
    /*document.getElementById('sidebar-menu').setAttribute('aria-hidden', 'false');
  }else{*/
    document.querySelector('.PageOverlay').classList.remove('is-visible');
  /*}*/
}
document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.PageOverlay').addEventListener("click",function(){
    document.getElementById('sidebar-wishlist').setAttribute('aria-hidden', 'true');
    document.querySelector('.PageOverlay').classList.remove('is-visible');
  });

      let attempts = 0; // Initialize attempts counter
    const maxAttempts = 100; // Set maximum attempts

    const interval = setInterval(function() {
      // Check if the element exists
      if ($(".klaviyo-close-form").length) {
        $(".klaviyo-close-form").on("click", function() {
          $("div[aria-label='FLYOUT Form']").hide();
        });
        clearInterval(interval); // Stop the interval once the event is attached
      } else if (attempts >= maxAttempts) {
        clearInterval(interval); // Stop trying after max attempts
      }

      attempts++; // Increment the attempts counter
    }, 100); // Check every 100 milliseconds
    
    // Add event listeners for cart drawer open/close to hide/show Shopify chat
    const cartObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const sidebarCart = document.getElementById('sidebar-cart');
          if (sidebarCart) {
            if (sidebarCart.getAttribute('aria-hidden') === 'false') {
              // Cart drawer is open - hide the chat
              $("#shopify-chat").hide();
            } else {
              // Cart drawer is closed - show the chat
              $("#shopify-chat").show();
            }
          }
        }
      });
    });
    
    // Start observing the sidebar-cart for aria-hidden attribute changes
    const sidebarCart = document.getElementById('sidebar-cart');
    if (sidebarCart) {
      cartObserver.observe(sidebarCart, { attributes: true });
    }
    
    // Also listen for the cart:refresh event which might open the drawer
    document.documentElement.addEventListener('cart:refresh', function() {
      setTimeout(function() {
        const sidebarCart = document.getElementById('sidebar-cart');
        if (sidebarCart && sidebarCart.getAttribute('aria-hidden') === 'false') {
          $("#shopify-chat").hide();
        }
      }, 100); // Small delay to ensure the drawer has opened
    });
});

/*document.addEventListener("DOMContentLoaded", function() {
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    const attachedElements = new Set();

    const callback = function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const wishlistButtons = document.querySelector(".open-drawer-wishlist");
          wishlistButtons.forEach(button => {
            if (!attachedElements.has(button)) {
              button.addEventListener("click", function() {
                if (window.location.href.includes("/account")) {
                  window.location.href = "/account?tab=wishlist";
                } else {
                  loadWishlist("wishlist-guest-wrapper");
                  openWishlistDrawer();
                }
              });
              attachedElements.add(button);
            }
          });
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
});*/
/*fullfil or empty the heart icon depending if there are items in fav*/
document.addEventListener('DOMContentLoaded', function() {
    function updateHeartIcon() {
      var wishlistCount = 0;

      fetch('https://livewishlist.scriptengine.net/api/apps-wishlist', {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            uuid: window.app_UUID_ID,
            customer_id: window.app_customre_id,
            shopify_store_id: window.app_store_id,
            shopify_store: window.Shopify.shop,
            active_currency: 'EUR',
            shop: window.Shopify.shop
        })
    })
    .then(response => response.json())
    .then(data => {
      if(data.status){
        wishlistCount = data.data.length;
      }

      const heartIcon = document.querySelectorAll('.Header__Wrapper .wishlist-item-nav .Icon');
      heartIcon.forEach(icon => {
        if (wishlistCount >= 1) {
            icon.style.setProperty('fill', 'black', 'important');
            icon.style.setProperty('stroke', 'black', 'important');
        } else {
            icon.style.setProperty('fill', 'transparent', 'important');
            icon.style.setProperty('stroke', 'black', 'important');
        }
      })
    });
        

        
    }

    function observePopupAddition() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const wishlistPopup = document.querySelector('.wishlist-popup');
                    if (wishlistPopup) {
                        updateHeartIcon();
                    }
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    observePopupAddition();
    setTimeout(function(){updateHeartIcon();},500);
});


function setProductDeliveryDateEstimate(){
  console.log("setProductDeliveryDateEstimate");
   if (window.location.href.includes('zip-lou')) {
    return; // Exit function if zip-lou is in URL
  }
    let today = new Date();
    let daysToAdd = 2;
    // Add days while skipping weekends
    for (let i = 0; i < daysToAdd; i++) {
        today.setDate(today.getDate() + 1);
        // If Monday (1) or Sunday (0), add an extra day (saturday=6)
        if (today.getDay() == 0 || today.getDay() == 6) {
            daysToAdd++;
        }
    }
    let deliveryDateExpress = today;
    let formattedDate = deliveryDateExpress.toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long' });
    document.getElementById('text-delivery').innerHTML = '<span class="green-dot" style="display:inline-block;background:#5A8E53;width:8px;height:8px;border-radius:100px;margin-rigth:12px;"></span><span style="margin-left:12px;">En stock : livré chez vous <span id="delivery-date">'+formattedDate+'</span></span>';
    productLoadDeliveryInitialized = true;
}
var handleStockIndicationProductPage = function(qte_stock, txt_restock = "", availability_stock = false, inventory_policy = "deny", minimum_qte = -10, txt_preorder_delivery_date = "") {

    console.log("qte_stock",qte_stock);//-29
    console.log("txt_restock",txt_restock);//De retour en stock le 30 décembre
    console.log("availability_stock",availability_stock);//false
    console.log("inventory_policy",inventory_policy);//deny
    console.log("minimum_qte",minimum_qte);//-10000
    console.log("txt_preorder_delivery_date",txt_preorder_delivery_date);//

    // Check if there is stock
    let hasStock = (qte_stock > 0);
    console.log("hasStock",hasStock);
    // Check if it's a preorder
    let isPreorder = (availability_stock && qte_stock <= 0);
    console.log("isPreorder",isPreorder);

    // Check if the minimum qte is reached for preorder
    let isPreoderMinimumQteReached = (isPreorder && qte_stock <= minimum_qte);
    console.log("isPreoderMinimumQteReached",isPreoderMinimumQteReached);

    // Check if the product is unavailable
    let unavailable = (!hasStock && !isPreorder) || (isPreoderMinimumQteReached);
    console.log("unavailable",unavailable);

    // Display the text availability if there is stock or if there is a restock date or if there is a preorder delivery date
    let displayTextAvailability = (availability_stock && hasStock) || txt_restock != ""  || txt_preorder_delivery_date != "";
    console.log("displayTextAvailability",displayTextAvailability);
    // If the product is unavailable, show the out of stock message
    if(unavailable){
      console.log("unavailable");
      jQuery(".product-block .klaviyo-out-of-stock").show();
      jQuery(".product-block .add-to-cart-btn-available").hide();
      jQuery(".product-block #BIS_trigger").show();
      jQuery(".product-block #text-return-exchange-msg").hide();
      jQuery(".product-block #WAX_trigger").show();
      jQuery(".product-block .text-availability").hide();
    }else{
      console.log("available");
      jQuery(".product-block .klaviyo-out-of-stock").hide();
      jQuery(".product-block .add-to-cart-btn-available").show();
      jQuery(".product-block #BIS_trigger").hide();
      jQuery(".product-block #text-return-exchange-msg").show();
      jQuery(".product-block #WAX_trigger").hide();
      jQuery(".product-block .text-availability").show();
    }

    if(isPreorder && txt_preorder_delivery_date != "" && !unavailable){
      // If the product is a preorder and there is a preorder delivery date, show the preorder delivery date
      $(".gf_add-to-cart").text("Précommander");
      console.log("displaying preorder delivery date");
      document.getElementById('text-delivery').innerHTML = `<span class='orange-dot'></span><span style='margin-left:12px;'>${txt_preorder_delivery_date}</span>`;
    }else if(isPreorder && unavailable && txt_preorder_delivery_date != ""){
      // If the product is a preorder and it's unavailable and there is a preorder delivery date, show the preorder delivery date
      $(".gf_add-to-cart").text("Précommander");
      console.log("displaying restock date");
      document.getElementById('text-delivery').innerHTML = `<span class='orange-dot'></span><span style='margin-left:12px;'>${txt_restock}</span>`;
    }else if(unavailable && txt_restock != ""){
      // If the product is unavailable and there is a restock date, show the restock date
      console.log("displaying restock date");
      $(".gf_add-to-cart").text("Créer une alerte");
      document.getElementById('text-delivery').innerHTML = `<span class='orange-dot'></span><span style='margin-left:12px;'>${txt_restock}</span>`;
    }else if(!unavailable && !isPreorder){
      // If the product is available and there is no preorder, show the delivery estimate
      console.log("displaying delivery estimate");
      $(".gf_add-to-cart").text("Ajouter au panier");
      setProductDeliveryDateEstimate();
    }else{
      displayTextAvailability = false;
      console.log("hiding text availability");
      document.getElementById('text-delivery').innerHTML = "";
      jQuery(".product-block .text-availability").hide();
    }

    if(displayTextAvailability){
      jQuery(".product-block .text-availability").show();
    }
  
    // Display the stock left indicator if there is low stock and the inventory policy is deny
    if(qte_stock > 0 && qte_stock <= 5 && inventory_policy == "deny"){
      if(qte_stock == 1){
        $(".stock-left-indicator").html(`<span style="color: rgb(0, 0, 0);">Plus que <span class="stock-left-indicator-number">${qte_stock}</span> pièce en stock !</span>`);
      }else{
        $(".stock-left-indicator").html(`<span style="color: rgb(0, 0, 0);">Plus que <span class="stock-left-indicator-number">${qte_stock}</span> pièces en stock !</span>`);
      }
      $(".stock-left-indicator").show();
    }else{
      $(".stock-left-indicator").hide();
    }
}

if (isSafari()) {
  document.body.classList.add('no-animation');
}


const addVariantToCart = function(items, callback = () => {}) {  
  const newData = {
    items: [...items]
  };
  console.log("addVariantToCart", JSON.stringify(newData));
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(newData)
  }).then(response => response.json()).then(data => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    callback();
  });
}



/* HERE we extracted the functions from Gempage that allow us the make actions when swatches are clicked on desktop or selected are changed on mobile */
document.addEventListener('DOMContentLoaded', function() {

  // Wait until jQuery is loaded
  if (!window.jQuery) {
    return setTimeout(arguments.callee, 50);
  }

  // Poll for the swatch elements to exist
  var swatchInterval = setInterval(function() {

    /* DESKTOP SWATCHES */
    if ($(".gf_swatch").length > 0) {
      // Attach our custom click handler (with a namespace to prevent duplicate attachments)
      $(".gf_swatch").off("click.customSwatch").on("click.customSwatch", function(e) {
        // Clear the polling interval once a swatch is clicked
        clearInterval(swatchInterval);
        
        // Get variant information
        var variantid = $("#m-1635858395114 .module").attr("data-current-variant");
        var variantoption1 = $(".gf_swatches-option1 .gf_swatch.gf_selected").attr("data-value");
        var variantoption2 = $(".gf_swatches-option2 .gf_swatch.gf_selected").attr("data-value");
        console.log("variantid",variantid);
        console.log("variantoption1",variantoption1);
        console.log("variantoption2",variantoption2);

        /*if (window.innerWidth >= 768) {*/
          console.log("New swatch selected from custom.js theme file");
          variantChanged = true;
          currentVarId = variantid;
          // Update wishlist engines with the new variant id
          $(".wishlist-engine").get(0).dataset.variant_id = currentVarId;
          $(".wishlist-engine").get(1).dataset.variant_id = currentVarId;

          // Build the variant key using option1 and option2
          let varName = variantoption1 + "_";
          if (variantoption2) {
            varName += variantoption2;
          }
          console.log("varName",varName);
          // Get the full variant info
          variantFullInfo = variant_info_full[variantid];

          console.log("variantFullInfo",variantFullInfo);

          // Update stock and preorder info using your handler function
          handleStockIndicationProductPage(
            realVariantStocks[variantid],
            txt_variant_restock[varName],
            variantFullInfo.available,
            variantFullInfo.inventory_policy,
            variant_preorder_limits[varName],
            txt_variant_preorder_delivery_date[varName]
          );

          // Update the UI: change the selected color text, and re-prepend the selected swatch
          $(".product-block .selected-color-txt").text(variantoption1);
          $(".product-block .swatches-desktop .gf_swatches-selector[data-name=Couleur]")
            .prepend($(".product-block .swatches-desktop .gf_swatches-selector[data-name=Couleur] .gf_selected"));

          jQuery(".product-block .selected-color-txt").text(variantoption1);
          $(".product-block .variants-mobile .gf_swatches-selector[data-name=Couleur]")
            .prepend($(".product-block .variants-mobile .gf_swatches-selector[data-name=Couleur] .gf_selected"));

          // If owl carousels are in use, update them accordingly
          if (isOwlFunctionsInitialized) {
            deleteAllFromOwlHeader();
            addToOwlHeader($($(".gf_selected").get(0)).attr("data-value"));
            owlHeader.trigger("to.owl.carousel", [0, 300]);
            owlThumbnails.trigger("to.owl.carousel", [0, 300]);
            $(".choosed-variante").text($($(".gf_selected").get(0)).attr("data-value"));
          }

          selectedVariantOnLoad = variantoption1;
          ajaxLoaderUpsellProductPage();
        /*}*/
      });
    }
    /*****************/
    
    /* MOBILE SELECT */
    /*if ($("select.single-option-selector-product").length > 0) {
      if (window.innerWidth < 768) {
        $("select.single-option-selector-product").off("change.customSelect").on("change.customSelect", function(e) {
          // Clear the polling interval once a swatch is clicked
          clearInterval(swatchInterval);
          
          console.log("New variant selected from custom.js theme file on mobile");
          // Get variant information
          var variantid = $("#m-1635858395114 .module").attr("data-current-variant");
          var variantoption1 = $("#SingleOptionSelector-product-0").val();
          var variantoption2 = $("#SingleOptionSelector-product-1").val();

          variantFullInfo = variant_info_full[variantid];

          console.log("set fromSelectOptionVariant = true");
          fromSelectOptionVariant = true;
          
          $(".wishlist-engine").get(0).dataset.variant_id = variantid;
          $(".wishlist-engine").get(1).dataset.variant_id = variantid;
          
          let varName = variantoption1 + "_";
            if(variantoption2){
              varName += variantoption2;
            }
            
          setTimeout(function() {
            // Update stock and preorder info using your handler function
            handleStockIndicationProductPage(
              realVariantStocks[variantid],
              txt_variant_restock[varName],
              variantFullInfo.available,
              variantFullInfo.inventory_policy,
              variant_preorder_limits[varName],
              txt_variant_preorder_delivery_date[varName]
            );
          }, 100);
      
          selectedVariantOnLoad = variantoption1;
          setTimeout(ajaxLoaderUpsellProductPage, 300);
          setTimeout(function(){ fromSelectOptionVariant = false;console.log("set fromSelectOptionVariant = false (500)"); }, 500);
          setTimeout(function(){fromSelectOptionVariant=false;console.log("set fromSelectOptionVariant = false (1000)");},1000);
          
        });
      }
    }*/
    /*****************/

    
  }, 250); // Check every 250 ms



  // MESSAGE INTERVAL ON PRODUCT PAGE
  /*
  This interval is used to display 2 differents messages on the product page under the ATC btn
  - The first message is the stockIndication
  - The second message is "Retours et échanges gratuits*"
  */
  var messageInterval = setInterval(function() {
    if ($(".product-block").length > 0) {
      const stockIndicationElement = $(".product-block .text-availability");
      const bisTriggerElement = $(".product-block #BIS_trigger");
      const bisTriggerElementIsVisible = bisTriggerElement.is(":visible");
      const returnExchangeElement = $(".product-block .return-exchange-message");
      const elementStockIndicationWithID = document.getElementById('text-delivery');
      const elementReturnExchangeWithID = document.getElementById('text-return-exchange-msg');
      /*console.log("elementStockIndicationWithID",elementStockIndicationWithID);
      console.log("elementReturnExchangeWithID",elementReturnExchangeWithID);
      console.log("elementStockIndicationWithID HTML",elementStockIndicationWithID.innerHTML);
      console.log("elementReturnExchangeWithID HTML",elementReturnExchangeWithID.innerHTML);
      console.log("messageInterval");*/
      if(!bisTriggerElementIsVisible){
        if(stockIndicationElement.hasClass("interval-hide")){
          if(elementStockIndicationWithID.innerHTML != ""){
            returnExchangeElement.fadeOut(250, function() {
              returnExchangeElement.addClass("interval-hide");
              stockIndicationElement.fadeIn(250);
              stockIndicationElement.removeClass("interval-hide");
            });
          }
        }else{
          if(elementReturnExchangeWithID.innerHTML != ""){
            stockIndicationElement.fadeOut(250, function() {
              stockIndicationElement.addClass("interval-hide");
              returnExchangeElement.fadeIn(250);
              returnExchangeElement.removeClass("interval-hide");
            });
          }
        }
      }
    }
  }, 5000);
  
});
